export const ProductMap = {
    'AutoCheck Auctions': 'aca',
    'AutoCheck Insurance': 'aci',
    'VIN Cross Check': 'vxc',
};

// reverses the key / value of the ProductMap
const flip = (prod) => {
  const flippedKeyValue = {};
  Object.keys(prod).forEach((key) => { flippedKeyValue[prod[key]] = key; });
  return flippedKeyValue;
};

export const ProductMapReversed = flip(ProductMap);



// WEBPACK FOOTER //
// ./src/helpers/ProductMap.js